import React from "react";
import {
  SkeletonText,
  SkeletonButton,
  SkeletonFilters,
} from "../../UI/DesignStandards";

const TournamentResultsSkeleton = () => {
  return (
    <div
      role="status"
      aria-label="Loading standings"
      aria-live="polite"
    >
      <div className="card-board overflow-hidden mb-6">
        <div className="bg-brand-charcoal text-brand-cream px-6 py-4">
          <h1 className="font-display font-bold text-xl text-brand-cream tracking-tight">
            Board
          </h1>
          <p className="text-sm text-brand-mist mt-1">
            Places from posted scores.
          </p>
        </div>
        <div className="p-6">
          <div className="flex gap-2 mb-6">
            <SkeletonButton size="md" width="24" />
            <SkeletonButton size="md" width="24" />
          </div>
          <SkeletonFilters filterCount={3} />
        </div>
      </div>

      <div className="card-board overflow-hidden">
        <div className="px-4 sm:px-6 pt-4 pb-2">
          <SkeletonText size="md" width="1/4" className="h-6" />
        </div>

        <div className="overflow-x-auto">
          <div className="bg-white px-2 sm:px-3 md:px-6 py-2 sm:py-3 border-b border-brand-charcoal/10">
            <div className="flex gap-2 sm:gap-3 md:gap-4">
              <SkeletonText
                size="xs"
                className="h-3 sm:h-4 w-12 sm:w-16 flex-shrink-0"
              />
              <SkeletonText
                size="xs"
                className="h-3 sm:h-4 w-20 sm:w-24 md:w-28 flex-shrink-0 max-w-[120px] sm:max-w-none"
              />
              <SkeletonText
                size="xs"
                className="h-3 sm:h-4 w-16 sm:w-20 flex-shrink-0"
              />
              <SkeletonText
                size="xs"
                className="h-3 sm:h-4 w-16 sm:w-20 flex-shrink-0"
              />
            </div>
          </div>

          {[...Array(5)].map((_, index) => (
            <div
              key={index}
              className={`px-2 sm:px-3 md:px-6 py-3 sm:py-4 border-b border-brand-charcoal/10 ${
                index % 2 === 0 ? "bg-white" : "bg-brand-cream/60"
              }`}
            >
              <div className="flex gap-2 sm:gap-3 md:gap-4">
                <SkeletonText
                  size="xs"
                  className="h-3 sm:h-4 w-8 flex-shrink-0"
                />
                <SkeletonText
                  size="xs"
                  className="h-3 sm:h-4 w-24 sm:w-32 md:w-36 flex-shrink-0 max-w-[120px] sm:max-w-none"
                />
                <SkeletonText
                  size="xs"
                  className="h-3 sm:h-4 w-16 sm:w-20 flex-shrink-0"
                />
                <SkeletonText
                  size="xs"
                  className="h-3 sm:h-4 w-16 sm:w-20 flex-shrink-0"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="sr-only" aria-live="polite">
        Loading tournament results. Please wait while the data is being
        prepared.
      </div>
    </div>
  );
};

export default TournamentResultsSkeleton;
